<template>
	<div>
		<div id="tabs" class="container">
  
		    <div class="tabs">
		        <a v-on:click="activetab='1'" v-bind:class="[ activetab === '1' ? 'active' : '' ]">Sole Proprietorship - Entity Info</a>
		    </div>

		    <div class="content">
		        <div v-if="activetab ==='1'" class="tabcontent">
		            <div class="col-md-12 p-l-r-0 f-left">
						<div class="form-group col-md-6  f-left">
							<p class="qustion_label">Name (in full)</p>
	            			<p class="ans_label">{{prop_owners.name}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Mobile Number</p>
	            			<p class="ans_label">{{prop_owners.mobile_no}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Email ID</p>
	            			<p class="ans_label">{{prop_owners.email_id}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Date of Birth</p>
	            			<p class="ans_label">{{prop_owners.dob | FormatDate('DD-MM-YYYY')}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">PAN Number</p>
	            			<p class="ans_label">{{prop_owners.pan_number}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Address</p>
	            			<p class="ans_label">{{prop_owners.address}}</p>
		                </div>
		            </div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">PAN (Self-Attested)</p>
	            			<p class="ans_label">PAN.pdf <span><a :href="prop_owners.pan_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Aadhar (Self-Attested)</p>
	            			<p class="ans_label">Aadhar.pdf <span><a :href="prop_owners.aadhar_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Passport size photo</p>
	            			<p class="ans_label">Passport.pdf <span><a :href="prop_owners.passport_size_photo" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left border-seperator"></div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-12  f-left">
							<p class="qustion_label">Brief note on the object of business</p>
	            			<p class="ans_label">{{prop_owners.brief_note}}</p>
		                </div>
		            </div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Registered office of the proposed business</p>
	            			<p class="ans_label">{{prop_owners.registered_office}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">{{prop_owners.registered_office}}</p>
	            			<p class="ans_label">Agreement.pdf <span><a :href="prop_owners.registered_office_doc_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Any Utility Bill</p>
	            			<p class="ans_label">Utility.pdf <span><a :href="prop_owners.any_utility_bill_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-12  f-left">
							<p class="qustion_label">NOC if rented premise or property tax receipt (if business premise self owned)</p>
	            			<p class="ans_label">receipt.pdf <span><a :href="prop_owners.noc" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Authorization Letter</p>
	            			<p class="ans_label">Authorization.pdf <span><a :href="prop_owners.authorization_letter_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
		        </div>
		    </div>
		  
		</div>
	</div>
</template>

<script>
export default {
    name:'sole_form_preview',
	props:['prop_owners'],
     watch:{
       
    },
    data() {
        return {
        	activetab: '1'
        }
    },
    methods: {

    }
};

</script>